import React, { useEffect, useState } from 'react';
import { Trophy } from 'lucide-react';
import { useAuth } from '../utils/AuthContext';
import type { EmployeeAwardGrant } from '../types';
import { subscribeToUserAwardGrants } from '../utils/employeeAchievements';
import AchievementTrophyCard from '../components/achievements/AchievementTrophyCard';
import '../components/pm/pm-shared.css';
import './OperationsHub.css';
import './PeopleHubPage.css';
import './PeopleAchievementsPage.css';

const PeopleAchievementsPage: React.FC = () => {
  const { user } = useAuth();
  const [grants, setGrants] = useState<EmployeeAwardGrant[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.id) {
      setGrants([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    return subscribeToUserAwardGrants(user.id, next => {
      setGrants(next);
      setLoading(false);
    });
  }, [user?.id]);

  return (
    <div className="people-hub-route-root people-achievements-route">
      <div className="ops-hub-toolbar">
        <div className="ops-hub-toolbar-left">
          <div>
            <h2 className="ops-hub-title people-achievements-title">
              <Trophy size={20} aria-hidden className="people-achievements-title-icon" />
              Certifications &amp; Achievements
            </h2>
            <p className="people-hub-subtitle people-achievements-subtitle">
              Your official (and unofficial) credentials. Displayed here for personal morale only.
            </p>
          </div>
        </div>
      </div>

      <div className="people-hub-body pm-scroll">
        <div className="people-hub-panel people-achievements-panel">
          {loading ? (
            <p className="people-achievements-loading">Loading your trophy case…</p>
          ) : grants.length === 0 ? (
            <div className="people-achievements-empty">
              <div className="people-achievements-empty-icon" aria-hidden>
                <Trophy size={48} strokeWidth={1.5} />
              </div>
              <h3 className="people-achievements-empty-title">No certifications yet.</h3>
              <p className="people-achievements-empty-copy">Keep surviving standups. Glory may find you.</p>
            </div>
          ) : (
            <div className="people-achievements-grid">
              {grants.map(grant => (
                <AchievementTrophyCard key={grant.id} grant={grant} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PeopleAchievementsPage;
